package common.constants

class KeyConstant {
    companion object {
        val appStorySeen = "AppStorySeen"
        val encryptionIV = "EncryptionIV"
        val encryptionSalt = "EncryptionSalt"
        val isAccepted = "IsAccepted"
        val loginDetails = "UserLoginDetails"
        var content = "Content"
        val contentType = "ContentType"
        val allContacts = "AllContacts"
        val conversationID = "ConversationID"
        val lastMessageDetails = "lastMessageDetails"
        val time = "Time"
        val sentRequest = "SentRequest"
        val receivedRequest = "ReceivedRequest"
        val blockList = "BlockList"
        val lastSeen = "LastSeen"
        val versionName = "VersionName"
        val OTP = "OTP"
        val id = "ID"
        val _id = "_id"
        val roleType = "RoleType"

        val payload = "Payload"
        val message = "Message"
        val messageID = "MessageID"
        val adminUsers = "AdminUsers"
        val adminUserProfiles = "AdminUserProfiles"
        val participants = "Participants"
        val participantsProfiles = "ParticipantProfiles"
        val groupName = "GroupName"
        val groupDescription = "GroupDescription"
        val ownerUserID = "OwnerUserID"
        val employeeUserID = "EmployeeUserID"
        val employeeID = "EmployeeID"
        val attendanceDate = "AttendanceDate"
        val isPresent = "IsPresent"

        val userId = "UserID"
        var selectedBusiness = "SelectedBusiness"
        var businessID = "BusinessID"
        var toBusinessID = "ToBusinessID"
        var fromBusinessID = "FromBusinessID"
        var businessTypeID = "BusinessTypeID"
        val business = "Business"
        val customer = "Customer"
        val customerName = "CustomerName"
        val customerID = "CustomerID"
        val customerMobile = "CustomerMobile"
        val vehicleNumber = "VehicleNumber"
        val IGST = "IGST"
        val CGST = "CGST"
        val SGST = "SGST"
        val VAT = "VAT"
        val CESS = "CESS"
        val tax = "Tax"
        val MRP = "MRP"
        const val price = "Price"
        const val productPrice = "ProductPrice"
        val pricing = "Pricing"
        val finalPrice = "FinalPrice"
        val costPrice = "CostPrice"
        val saleDate = "SaleDate"
        val saleTime = "SaleTime"
        val discount = "Discount"
        val instantDiscount = "InstantDiscount"
        val success = "Success"
        val productID = "ProductID"
        val productName = "ProductName"
        val product = "Product"
        val roomId = "ROOM_ID"
        val mobileNumber = "MobileNumber"
        val emailId = "EmailID"
        val password = "Password"
        val deviceId = "DeviceID"
        val featureObjectID = "FeatureObjectID"
        val countryCode = "CountryCode"
        val state = "State"
        val city = "City"
        val area = "Area"
        val landMark = "LandMark"
        val point = "Point"
        val location = "Location"
        val coordinates = "coordinates"
        val latitude = "Latitude"
        val longitude = "Longitude"
        val fcmToken = "FCMToken"
        val created = "Created"
        val updated = "Updated"
        val profilePicture = "ProfilePicture"
        val friendList = "FriendList"
        val profile = "Profile"
        val profiles = "Profiles"
        val createdAt = "CreatedAt"
        val updatedAt = "UpdatedAt"
        val numberOfDays = "NumberOfDays"
        val creator = "Creator"
        val transactions = "Transactions"
        val sales = "Sales"
        val orderItems = "OrderItems"
        val salesID = "SalesID"
        val quantity = "Quantity"
        val comment = "Comment"


        val to = "to"
        val notification = "notification"
        val title = "Title"
        val body = "body"
        val data = "Data"
        val imageData = "ImageData"
        val authorization = "Authorization"
        val senderId = "SenderID"
        val receiverId = "ReceiverID"
        val senderFCM = "SenderFCM"
        val receiverFCM = "ReceiverFCM"
        val type = "Type"
        val isRead = "IsRead"
        val isSent = "IsSent"
        val isReceived = "IsReceived"
        val isUploaded = "IsUploaded"
        val isDownloaded = "IsDownloaded"
        val isDeleted = "IsDeleted"
        val isTyping = "IsTyping"
        val invoice = "Invoice"
        val invoiceId = "InvoiceID"
        val invoiceNumber = "InvoiceNumber"

        val userCredentials = "user_credentials"
        val trainerCredentials = "TrainerCredentials"
        val membershipDetails = "membership_details"
        val customerBarcode = "Barcode"
        val barCode = "BarCode"
        val barcode = "BarCode"
        val height = "height"
        val weight = "weight"
        val aadhaarNumber = "aadhaar_number"

        val dateOfBirth = "date_of_birth"
        val address = "Address"
        val house = "House"
        val flatNumber = "FlatNumber"
        val zipCode = "ZipCode"
        val currentGymId = "current_gym_id"
        val joiningDate = "current_gym_joining_date"
        val startDate = "StartDate"
        val endDate = "EndDate"
        val dueDate = "DueDate"
        val priority = "Priority"
        val lastGymId = "last_gym_id"
        val date = "Date"


        val gymId = "gym_id"
        val gstNumber = "gst_number"
        val workingDays = "working_days"
        val workingDay = "working_day"
        val hours = "Hours"
        val panNumber = "pan_number"

        //For workout
        val uniqueId = "UniqueID"
        val name = "Name"
        val gender = "Gender"
        val status = "Status"
        val statusDescription = "StatusDescription"
        val imageUrl = "ImageURL"
        val image = "Image"

        val model = "model"
        val mode = "Mode"
        val description = "Description"
        val manageInventory = "ManageInventory"
        val taxIncluded = "TaxIncluded"
        val instruction = "Instruction"
        val steps = "Steps"
        val repetition = "Repetition"
        val category = "Category"
        val categoryId = "CategoryID"
        val subCategoryID = "SubCategoryID"
        val toUserId = "ToUserID"
        val isGroup = "ISGroup"
        val fromUserId = "FromUserID"
        val friendRequestId = "FriendRequestID"
        val fromDetails = "fromDetails"
        val toDetails = "toDetails"
        val fromUser = "FromUser"
        val toUser = "ToUser"
        val language = "Language"
        val localization = "Localization"
        val dialCode = "DialCode"

        val workout = "Workout"
        val sets = "Sets"

        val workoutPlan = "WorkoutPlan"


        val muscleSecondary = "MusclesSecondary"
        val musclePrimary = "MusclesPrimary"
        val equipment = "Equipment"
        val exercise = "Exercise"
        val exerciseID = "ExerciseID"

        val sentTime = "SentTime"
        val deliveredTime = "DeliveredTime"
        val readTime = "ReadTime"
        val acceptedTime = "AcceptedTime"
        val search = "search"

        val dynamicLink = "DynamicLink"

        val companyId = "CompanyID"
        val company = "Company"
        val designation = "Designation"
        val designationID = "DesignationID"
        val technologies = "Technologies"
        val working = "Working"
        val fromDate = "FromDate"
        val toDate = "ToDate"
        val taskDetails = "TaskDetails"
        val taskID = "TaskID"
        val taskAttachmentID = "TaskAttachmentID"
        val fileURL = "FileURL"

        val lastSyncDate = "LastSyncDate"

        //Order
        val orderId = "OrderID"
        val orderStatus = "OrderStatus"
        val orderNumber = "OrderNumber"
        val orderType = "OrderType"
    }

}